// Auto-generated normalizer for table: ExamenesIntentos
export function examenesIntentosNormalize(row) {
  return {
    idExamenIntento: row.idExamenIntento ?? row.IdExamenIntento ?? row['IdExamenIntento'] ?? 0,
    idExamen: row.idExamen ?? row.IdExamen ?? row['IdExamen'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    fechaIntento: row.fechaIntento ?? row.FechaIntento ?? row['FechaIntento'] ?? null,
    resultado: row.resultado ?? row.Resultado ?? row['Resultado'] ?? '',
    calificacion: row.calificacion ?? row.Calificacion ?? row['Calificacion'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
